import { Box } from '@mui/material';
import type { ColDef } from '@siloreal:modules:private/silobag-list/config/extra/types';
import { FALLBACK_STRING, FieldCellStack, FieldPrimaryText, MetaRow } from './column-field-ui';
import * as HOOKS from '@siloreal:shared:hooks';

type CountrysideCellProps = {
  countrysideName?: string | null;
  lotName?: string | null;
};

export function buildCountrysideColumn(): ColDef {
  return {
    field: 'countryside_id',
    headerName: HOOKS.useLocale.getState().t('temp.common.countryside'),
    minWidth: 240,
    flex: 1,
    renderCell: ({ row }) => (
      <CountrysideCell countrysideName={row.lots?.countrysides?.name} lotName={row.lots?.name} />
    ),
  };
}

function CountrysideCell({ countrysideName, lotName }: CountrysideCellProps) {
  const hasCountryside = Boolean(countrysideName?.trim());
  const hasLot = Boolean(lotName?.trim());
  const primaryName = countrysideName?.trim() || FALLBACK_STRING;
  const secondaryName = lotName?.trim() || FALLBACK_STRING;
  const i18n = HOOKS.useLocale();

  return (
    <FieldCellStack>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <FieldPrimaryText
          title={hasCountryside ? primaryName : i18n.t('temp.common.countryside_unavailable')}
          disabled={!hasCountryside}
        >
          {primaryName}
        </FieldPrimaryText>

        <MetaRow
          tag="LOTE"
          disabled={!hasLot}
          valueTitle={hasLot ? secondaryName : i18n.t('temp.common.lot_unavailable')}
        >
          {secondaryName}
        </MetaRow>
      </Box>
    </FieldCellStack>
  );
}
